import { IAuthErrorResponse } from '@app/api/interfaces/auth.interface';
import { AuthStep } from '@app/core/authentication/enums/auth-step.enum';
import { IAuthStepData } from '@app/core/authentication/interfaces/auth-step-data';

export const authKey = 'auth';

export interface IAuthState {
  initialized: boolean;
  loading: boolean;
  step: AuthStep;
  stepData: IAuthStepData;
  error: IAuthErrorResponse | null;
}

export const initialState: IAuthState = {
  initialized: false,
  loading: false,
  step: AuthStep.Login,
  stepData: null,
  error: null,
};
